import { createSelector } from "reselect";
import get from "src/lib/get";
import { getData } from ".";

export const canBeSentNow = createSelector(getData, (data) => {
  return get(data, "can_send_box_now", false);
});
